module.exports = __webpack_public_path__ + "img/ocean-hotel-4.5e367e0d.jpg";